import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@ps/core-config';
import { BulkStats, Survey } from '@ps/survey-utils';
import { map, Observable } from 'rxjs';
import { BulkStatsDto } from './dtos/bulk-edit.dto';
import { MultiSurveyReportPayloadDto } from './dtos/reports.dto';
import { BulkStatsMapper } from './mapper/bulk-stats.mapper';
import { ApiStatusMessageResponse } from '@ps/utils';

@Injectable({ providedIn: 'root' })
export class ProjectApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _reportServiceUrl = this._env.pureSpectrum.reportServiceUrl;

  private readonly _bulkStatsMapper = new BulkStatsMapper();

  public getSurveyBulkStats(surveyIds: number[]): Observable<BulkStats> {
    return this._http
      .post<BulkStatsDto>(`${this._baseUrl}/buyers/v2/projects/stats`, {
        surveyIds,
      })
      .pipe(map((response) => this._bulkStatsMapper.fromDto(response)));
  }

  public getCombinedSummaryReport(
    email: string,
    selectedSurveys: Survey[],
  ): Observable<ApiStatusMessageResponse> {
    const body: MultiSurveyReportPayloadDto = {
      email,
      surveys: selectedSurveys.map((survey) => survey.id),
    };
    return this._http.post<ApiStatusMessageResponse>(
      `${this._reportServiceUrl}/multi-surveys`,
      body,
    );
  }
}
